import { useNavigate } from "react-router-dom";
// src/pages/Dashboard.jsx вЂ” Phase 2 / Changes A B C D F
//
// OPERATOR VIEW: Risk Now + What Happened + What VIRAJ Did + Compact Decision Timeline
// ANALYST VIEW: + Financial Story + Daily Breakdown + Protection Events + Override Memory + System

import { useEffect, useState } from "react";
import { workerClient }        from "../api/workerClient";

import HeroLayer         from "../components/hero/HeroLayer";
import CrisisHighlight   from "../components/dashboard/CrisisHighlight";
import RecoveryHighlight from "../components/dashboard/RecoveryHighlight";
import AutoActionLog     from "../components/dashboard/AutoActionLog";
import FinanceChartV10   from "../components/dashboard/FinanceChartV10";
import DailyBreakdownV3  from "../components/dashboard/DailyBreakdownV3";
import SystemHealthBlock from "../components/dashboard/SystemHealthBlock";
import LogsBlock         from "../components/dashboard/LogsBlock";
import DecisionTimeline  from "../components/engine/DecisionTimeline";

const SectionDivider = ({ label }) => (
  <div style={{ display:"flex", alignItems:"center", gap:12 }}>
    <div style={{ height:1, flex:1, background:"var(--border-subtle)" }} />
    {label && <span style={{ fontFamily:"var(--font-mono)", fontSize:9, letterSpacing:"0.18em",
                             textTransform:"uppercase", color:"var(--text-muted)", flexShrink:0 }}>{label}</span>}
    <div style={{ height:1, flex:1, background:"var(--border-subtle)" }} />
  </div>
);

function ViewToggle({ mode, onChange }) {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%" }}>
      <div style={{ fontFamily:"var(--font-mono)", fontSize:9, letterSpacing:"0.14em",
                    textTransform:"uppercase", color:"var(--text-muted)" }}>
        Performance Overview
      </div>
      <div style={{ display:"flex", gap:4 }}>
      {["operator","analyst"].map(m => (
        <button key={m} onClick={() => onChange(m)} style={{
          fontFamily:"var(--font-mono)", fontSize:9, letterSpacing:"0.12em", textTransform:"uppercase",
          padding:"4px 12px", borderRadius:"var(--radius-sm)",
          border:`1px solid ${mode===m ? "var(--accent-primary)" : "var(--border-subtle)"}`,
          background: mode===m ? "var(--accent-primary)" : "transparent",
          color: mode===m ? "#fff" : "var(--text-muted)", cursor:"pointer" }}>
          {m === "operator" ? "Operator" : "Analyst"}
        </button>
      ))}
      </div>
    </div>
  );
}

// Risk Now вЂ” quick operational status
function RiskNowBlock({ riskStatus, riskScore, loading }) {
  if (loading) return <div className="skeleton" style={{ height:52, borderRadius:"var(--radius)" }} />;
  const CFG = {
    low:     { color:"var(--success)", bg:"var(--success-bg)", border:"var(--success-border)", label:"LOW RISK" },
    medium:  { color:"var(--warning)", bg:"var(--warning-bg)", border:"var(--warning-border)", label:"MEDIUM RISK" },
    high:    { color:"var(--danger)",  bg:"var(--danger-bg)",  border:"var(--danger-border)",  label:"HIGH RISK" },
    critical:{ color:"var(--danger)",  bg:"var(--danger-bg)",  border:"var(--danger-border)",  label:"CRITICAL" },
    unknown: { color:"var(--text-muted)", bg:"var(--bg-card)", border:"var(--border-subtle)", label:"UNKNOWN" },
  };
  const cfg = CFG[riskStatus ?? "unknown"] ?? CFG.unknown;
  const obs = riskScore != null && riskScore < 0.5;
  const confTxt = riskScore == null ? null : obs ? "LOW CONFIDENCE вЂ” OBSERVING" : riskScore >= 0.75 ? "HIGH CONFIDENCE" : "MEDIUM CONFIDENCE";
  return (
    <div style={{ padding:"12px 18px", borderRadius:"var(--radius)", background:cfg.bg,
                  border:`1px solid ${cfg.border}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
        <div style={{ width:7, height:7, borderRadius:"50%", background:cfg.color, boxShadow:`0 0 7px ${cfg.color}`, flexShrink:0 }} />
        <span style={{ fontFamily:"var(--font-mono)", fontSize:13, fontWeight:700, color:cfg.color }}>{cfg.label}</span>
        {obs && <span style={{ fontFamily:"var(--font-mono)", fontSize:9, color:"var(--action)", marginLeft:4 }}>в—Ћ OBSERVING</span>}
      </div>
      {confTxt && <span style={{ fontFamily:"var(--font-mono)", fontSize:9, letterSpacing:"0.1em", textTransform:"uppercase", color:"var(--text-muted)" }}>{confTxt}</span>}
    </div>
  );
}

// What VIRAJ Did вЂ” last action summary
function WhatVIRAJDid({ actions, loading }) {
  if (loading) return <div className="skeleton" style={{ height:44, borderRadius:"var(--radius)" }} />;
  const LABELS = { reduce_spend:"Spend Reduced", limit_budget:"Budget Limited",
                   pause_campaigns:"Campaigns Paused", monitor:"Monitoring Active",
                   observe:"Observing", alert:"Alert Raised", reduce:"Spend Reduced", pause:"Campaign Paused" };
  if (!actions?.length) return (
    <div style={{ padding:"11px 18px", borderRadius:"var(--radius)", background:"var(--bg-card)",
                  border:"1px solid var(--border-subtle)", fontFamily:"var(--font-mono)", fontSize:12, color:"var(--success)" }}>
      вњ“ No action needed В· Budget within parameters
    </div>
  );
  const last = actions[0];
  const label = LABELS[last.action_type ?? last.action] ?? (last.action_type ?? "Engine action").replace(/_/g," ");
  const ts = last.timestamp ? new Date(last.timestamp*1000).toLocaleString("en-GB",
    { day:"2-digit", month:"short", hour:"2-digit", minute:"2-digit" }) : "вЂ”";
  return (
    <div style={{ padding:"11px 18px", borderRadius:"var(--radius)", background:"var(--action-bg)",
                  border:"1px solid var(--action-border)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
      <div style={{ display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ color:"var(--action)", fontWeight:700 }}>вљЎ</span>
        <span style={{ fontFamily:"var(--font-mono)", fontSize:12, color:"var(--text-primary)", fontWeight:700 }}>{label}</span>
      </div>
      <span style={{ fontFamily:"var(--font-mono)", fontSize:10, color:"var(--text-muted)" }}>{ts}</span>
    </div>
  );
}

// Override Memory вЂ” Change F
function OverrideHistory({ actions }) {
  const cutoff7d = Date.now()/1000 - 7*86400;
  const recent = (actions ?? []).filter(a => Number(a.timestamp) >= cutoff7d).length;
  const sens = recent === 0 ? 1.0 : recent < 3 ? 0.8 : 0.6;
  const sensColor = sens === 1.0 ? "var(--success)" : sens === 0.8 ? "var(--warning)" : "var(--danger)";
  return (
    <div style={{ padding:"12px 18px", borderRadius:"var(--radius)", background:"var(--bg-card)",
                  border:"1px solid var(--border-subtle)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
      <div>
        <div style={{ fontFamily:"var(--font-mono)", fontSize:9, letterSpacing:"0.12em", textTransform:"uppercase", color:"var(--text-muted)", marginBottom:3 }}>Manual overrides вЂ” last 7 days</div>
        <div style={{ fontFamily:"var(--font-mono)", fontSize:12, color:"var(--text-secondary)" }}>{recent} override{recent!==1?"s":""} recorded</div>
      </div>
      <div style={{ textAlign:"right" }}>
        <div style={{ fontFamily:"var(--font-mono)", fontSize:9, color:"var(--text-muted)", marginBottom:2 }}>Sensitivity</div>
        <div style={{ fontFamily:"var(--font-mono)", fontSize:12, fontWeight:700, color:sensColor }}>{sens.toFixed(1)}</div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const navigate = useNavigate();
  const [trendData,   setTrendData]  = useState([]);
  const [actions,     setActions]    = useState([]);
  const [riskHistory, setRiskHistory]= useState([]);
  const [riskStatus,  setRiskStatus] = useState(null);
  const [riskScore,   setRiskScore]  = useState(null);
  const [loading,     setLoading]    = useState(true);
  const [health,      setHealth]     = useState(null);
  const [viewMode,    setViewMode]   = useState("operator");

  useEffect(() => {
    Promise.all([
      workerClient("/api/finance/trends"),
      workerClient("/api/antiloss/actions"),
      workerClient("/api/risk/history"),
      workerClient("/api/system/health"),
      workerClient("/api/risk/status"),
    ]).then(([trends, actRes, histRes, healthRes, statusRes]) => {
      if (Array.isArray(trends?.trend))    setTrendData(trends.trend);
      if (Array.isArray(actRes?.items))    setActions(actRes.items);
      if (Array.isArray(histRes?.items))   setRiskHistory(histRes.items);
      if (healthRes)                       setHealth(healthRes);
      if (statusRes?.risk_status)          setRiskStatus(statusRes.risk_status);
      if (statusRes?.risk_score != null)   setRiskScore(statusRes.risk_score);
    }).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
      {/* Return to Analyze */}
      <div data-no-print style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
        <button
          onClick={() => navigate("/analyze")}
          style={{
            fontFamily: "var(--font-mono)", fontSize: 10, cursor: "pointer",
            padding: "4px 10px", borderRadius: "var(--radius-sm)",
            background: "transparent", border: "1px solid var(--border-subtle)",
            color: "var(--text-muted)", display: "inline-flex", alignItems: "center", gap: 5,
          }}
        >
          ← Analyze
        </button>
      </div>

      <ViewToggle mode={viewMode} onChange={setViewMode} />

      {/* HERO вЂ” always */}
      <div className="hero-container"><HeroLayer /></div>

      {/* OPERATOR 1: Risk Now */}
      <SectionDivider label="Current status" />
      <RiskNowBlock riskStatus={riskStatus} riskScore={riskScore} loading={loading} />

      {/* OPERATOR 2: What Happened */}
      <SectionDivider label="What happened" />
      <CrisisHighlight riskHistory={riskHistory} loading={loading} />
      {viewMode === "analyst" && <RecoveryHighlight riskHistory={riskHistory} loading={loading} />}

      {/* OPERATOR 3: What VIRAJ Did */}
      <SectionDivider label="Last recommendation" />
      <WhatVIRAJDid actions={actions} loading={loading} />

      {/* OPERATOR 4: Compact Decision Timeline */}
      <SectionDivider label="Campaign history" />
      <DecisionTimeline
        campaignId="viraj_demo_01"
        compact={viewMode === "operator"}
        groupBy={viewMode === "analyst"}
        title=""
      />

      {/* ANALYST ONLY */}
      {viewMode === "analyst" && (<>
        <SectionDivider label="Actions taken" />
        <AutoActionLog actions={actions} loading={loading} />

        <SectionDivider label="Manual overrides" />
        <OverrideHistory actions={actions} />

        <SectionDivider label="Revenue & spend" />
        <FinanceChartV10 data={trendData} riskHistory={riskHistory} />
        <DailyBreakdownV3 breakdown={trendData} />

        <SectionDivider label="System status" />
        <SystemHealthBlock health={health} />
        <LogsBlock />
      </>)}

    </div>
  );
}


